import type { MouseEvent } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import type { BookmarksParams } from '../../../services/bookmarkCache';

type Section = Pick<BookmarksParams, 'section_type' | 'folder_id' | 'tag'> | 'highlights';

export function useRefreshActiveSection(isActive: boolean, section?: Section) {
  const queryClient = useQueryClient();

  return (event: MouseEvent<HTMLAnchorElement>) => {
    if (
      !isActive ||
      !section ||
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      (event.currentTarget.target && event.currentTarget.target !== '_self')
    ) {
      return;
    }

    const queryKey = section === 'highlights' ? ['highlights'] : ['bookmarks', section];

    // Invalidate all pages before Link navigates, so a cached page one refetches
    // on mount. Only refetch page one now if it's already mounted; fetching the
    // page we're about to leave would waste a request.
    void queryClient.invalidateQueries({ queryKey, refetchType: 'none' });
    void queryClient.refetchQueries({
      queryKey,
      type: 'active',
      predicate: ({ queryKey: key }) =>
        (section === 'highlights' ? key[1] : (key[1] as BookmarksParams).page) === 1,
    });
    void queryClient.invalidateQueries({ queryKey: ['currentUser'] });
  };
}
